import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { ProductType } from '@frontend/product/types';
import React from 'react';

const ID = 'product-type-select';
export const ProductTypeSelect = (props: Omit<SelectInputV2Props<string>, 'options'>) => {
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            options={Object.values(ProductType)
                .filter((v) => v != ProductType.UNKNOWN)
                .map((c) => ({ label: c, value: c }))}
            label={props.label || 'Product type'}
        />
    );
};
